import logout from "@/functions/logout";
import { Modal, notification } from "antd";
import { useSession } from "next-auth/react";
import React, { useEffect, useState } from "react";

export const SessionErrorHandler: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { data: session } = useSession();
    const [disabledModalVisible, setDisabledModalVisible] = useState(false);

    useEffect(() => {
        // this error bubbles up from [...nextauth].ts, refreshAccessToken()
        if (session?.['error'] === "TokenRevokedError") {
            setDisabledModalVisible(true);
        }
        if (session?.['error'] === "RefreshAccessTokenError") {
            notification['warning']({
                message: 'Login Required',
                description: 'Your session has ended. Redirecting to login page...'
            });
            logout(); // Force sign in to hopefully resolve error
        }
    }, [session]);

    return (
        <>
            {children}
            <Modal
                title={
                    <div className="w-full border-b border-gray-300 pb-2 text-xl">
                        Pesan Error
                    </div>
                }
                open={disabledModalVisible}
                onCancel={() => logout()}
                onOk={() => logout()}
                centered
                footer={false}
            >
                <div className='px-3 py-5'>
                    <p>Akun anda telah dinonaktifkan, untuk info lebih lanjut harap hubungi admin terkait.</p>
                </div>
            </Modal>
        </>
    );
};
